import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CategoriesSection } from '../components/CategoriesSection';
export function ClassesPage() {
  return <div className="bg-black text-white min-h-screen" data-id="element-259">
      <Header data-id="element-260" />
      <main className="pt-20" data-id="element-261">
        <div className="container mx-auto px-4 py-16" data-id="element-262">
          <h1 className="text-4xl md:text-5xl font-bold mb-8" data-id="element-263">
            Trading Classes
          </h1>
          <p className="text-xl text-gray-300 mb-12 max-w-3xl" data-id="element-264">
            Explore our comprehensive library of trading classes taught by
            industry experts. Master the skills you need to succeed in today's
            markets.
          </p>
        </div>
        <CategoriesSection data-id="element-265" />
      </main>
      <Footer data-id="element-266" />
    </div>;
}